import { render } from "./LanguageSwitch.vue?vue&type=template&id=4dd30654&ts=true&lang=pug"
import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__